import React, { Component } from 'react';
import { markupHelpers } from '../../../helpers/index';
import { Buttons } from '../../ui/index';
import { ConfirmDeleteDialogue } from '../../ui/ConfirmDeleteDialogue';

export default class EndorsementItem extends Component {
	constructor() {
		super();
		this.state = {
			isOpen: false,
		};
	}

	render() {
		const { body, hideButtonsFromMain } = this.props,
			{
				first_name,
				last_name,
				company_name,
				content,
				job_title,
				email_address,
			} = body;

		const convertedJobTitle = markupHelpers.escapeHtmlHelper(job_title),
			convertedCompanyName = markupHelpers.escapeHtmlHelper(company_name),
			convertedContent = markupHelpers.escapeHtmlHelper(content),
			convertedFirstName = markupHelpers.escapeHtmlHelper(first_name),
			convertedLastName = markupHelpers.escapeHtmlHelper(last_name);

		return (
			<div className="item-endorsements">
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">
						<img src="/images/icon-quote-02.png" className="icon-custom" />
					</div>
					<div className="col-8 col-lg-9 new-profile-info">
						<div className="endorsement-box">
							<p className="p-tag endorsement-text">{convertedContent}</p>
							<p className="p-tag endorsement-name">
								{convertedFirstName} {convertedLastName}
							</p>
							<p className="p-tag endorsement-position">
								{convertedJobTitle && `${convertedJobTitle}, `}
								{convertedCompanyName}
								{email_address && ` - ${email_address}`}
							</p>
						</div>
					</div>
					<div className="col-xs-12 col-md-4 col-lg-3 new-profile-controls">
						{!this.state.isOpen && (
							<ul className="buttons-left">
								<li>
									<Buttons.EndorsementsPublishButton {...this.props} />
								</li>
								<li>
									<Buttons.EndorsementsDeleteButton
										handleClick={() => this.setState({ isOpen: true })}
										text="Delete"
										hideButtonsFromMain={hideButtonsFromMain}
									/>
								</li>
							</ul>
						)}
						<ConfirmDeleteDialogue
							isOpen={this.state.isOpen}
							onCancel={() => this.setState({ isOpen: false })}
							{...this.props}
						/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/EndorsementItem.js